import React from 'react';
import { Row, Col, ProgressBar, Panel } from 'react-bootstrap';

import {
  ResponsiveContainer,
  ComposedChart,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  Area,
  Bar,
  Line,
} from 'recharts';

import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
} from 'react-simple-maps';

import StatWidget from '../components/Widget/StatWidget';
import UserList from '../components/UserList/UserList';
import ProductList from '../components/ProductList/ProductList';
import Chat from '../components/Chat/Chat';

const data = [
  { name: 'Product A', uv: 590, pv: 800, amt: 1400 },
  { name: 'Product B', uv: 868, pv: 967, amt: 1506 },
  { name: 'Product C', uv: 1397, pv: 1098, amt: 989 },
  { name: 'Product D', uv: 1480, pv: 1200, amt: 1228 },
  { name: 'Product E', uv: 1520, pv: 1108, amt: 1100 },
];

class DashboardPage extends React.Component {
  componentDidMount() {}
  render() {
    const browserStatFooter = () => {
      return (
        <Row>
          <Col sm={3} xs={6}>
            <div className="description-block border-right">
              <span className="description-percentage text-green">
                <i className="fa fa-caret-up" /> 17%
              </span>
              <h5 className="description-header">$35,210.43</h5>
              <span className="description-text">TOTAL REVENUE</span>
            </div>
          </Col>
          <Col sm={3} xs={6}>
            <div className="description-block border-right">
              <span className="description-percentage text-yellow">
                <i className="fa fa-caret-left" /> 0%
              </span>
              <h5 className="description-header">$10,390.90</h5>
              <span className="description-text">TOTAL COST</span>
            </div>
          </Col>
          <Col sm={3} xs={6}>
            <div className="description-block border-right">
              <span className="description-percentage text-green">
                <i className="fa fa-caret-up" /> 20%
              </span>
              <h5 className="description-header">$24,813.53</h5>
              <span className="description-text">TOTAL PROFIT</span>
            </div>
          </Col>
          <Col sm={3} xs={6}>
            <div className="description-block">
              <span className="description-percentage text-red">
                <i className="fa fa-caret-down" /> 18%
              </span>
              <h5 className="description-header">1200</h5>
              <span className="description-text">GOAL COMPLETIONS</span>
            </div>
          </Col>
        </Row>
      );
    };

    const browserStatProgressBar = () => {
      return (
        <Col md={4}>
          <p className="text-center">
            <strong>Goal Completion</strong>
          </p>
          <div className="progress-group">
            <span className="progress-text">Add Products to Cart</span>
            <span className="progress-number">
              <b>160</b>/200
            </span>
            <div className="progress sm">
              <ProgressBar now={20} bsStyle="warning" active />
            </div>
          </div>
          <div className="progress-group">
            <span className="progress-text">Complete Purchase</span>
            <span className="progress-number">
              <b>310</b>/400
            </span>
            <div className="progress sm">
              <ProgressBar now={40} bsStyle="success" active />
            </div>
          </div>
          <div className="progress-group">
            <span className="progress-text">Visit Premium Page</span>
            <span className="progress-number">
              <b>480</b>/800
            </span>
            <div className="progress sm">
              <ProgressBar now={60} bsStyle="info" active />
            </div>
          </div>
          <div className="progress-group">
            <span className="progress-text">Send Inquiries</span>
            <span className="progress-number">
              <b>250</b>/500
            </span>
            <div className="progress sm">
              <ProgressBar now={80} bsStyle="danger" active />
            </div>
          </div>
          <div className="progress-group">
            <span className="progress-text">Register</span>
            <span className="progress-number">
              <b>50</b>/500
            </span>
            <div className="progress sm">
              <ProgressBar now={20} active />
            </div>
          </div>
        </Col>
      );
    };

    const browserStatWidgets = () => {
      return (
        <Row>
          <Col md={3} sm={6} xs={12}>
            <StatWidget
              icon="chrome"
              title="Chrome"
              number="1,410"
              bg="red"
              progress={{ size: 50, desc: 'description' }}
            />
          </Col>
          <Col md={3} sm={6} xs={12}>
            <StatWidget
              icon="firefox"
              title="Firefox"
              number="1,410"
              bg="orange"
              progress={{ size: 50, desc: 'description' }}
            />
          </Col>
          <Col md={3} sm={6} xs={12}>
            <StatWidget
              icon="safari"
              title="Safari"
              number="1,410"
              bg="aqua"
              progress={{ size: 50, desc: 'description' }}
            />
          </Col>
          <Col md={3} sm={6} xs={12}>
            <StatWidget
              icon="internet-explorer"
              title="Internet Explorer"
              number="1,410"
              bg="purple"
              progress={{ size: 50, desc: 'description' }}
            />
          </Col>
        </Row>
      );
    };
    return (
      <div className="content-wrapper">
        <section className="content-header">
          <h1 className="content-title">
            Dashboard
            <small>Control panel</small>
          </h1>
          <ol className="breadcrumb">
            <li>
              <a>
                <i className="fa fa-dashboard" /> Home
              </a>
            </li>
            <li className="active">DashboardPage</li>
          </ol>
        </section>
        <section className="content">
          {browserStatWidgets()}
          <Row>
            <Col md={12}>
              <Panel header="Browsers Stat" footer={browserStatFooter()}>
                <Row>
                  <Col md={8}>
                    <p className="text-center">
                      <strong>Sales: 1 Jan, 2014 - 30 Jul, 2014</strong>
                    </p>
                    <div className="chart">
                      <ResponsiveContainer height={300}>
                        <ComposedChart width={600} height={300} data={data}>
                          <XAxis dataKey="name" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <CartesianGrid stroke="#f5f5f5" />
                          <Area
                            type="monotone"
                            dataKey="amt"
                            fill="#1AD6FD"
                            stroke="#1AD6FD"
                          />
                          <Bar dataKey="pv" barSize={20} fill="#1D77EF" />
                          <Line type="monotone" dataKey="uv" stroke="#FF3B30" />
                        </ComposedChart>
                      </ResponsiveContainer>
                    </div>
                  </Col>
                  {browserStatProgressBar()}
                </Row>
              </Panel>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Panel header="Recently Registered Users">
                <UserList />
              </Panel>
            </Col>
            <Col md={4}>
              <Panel header="Chats">
                <Chat />
              </Panel>
            </Col>
            <Col md={4}>
              <Panel header="Recently Added Products">
                <ProductList />
              </Panel>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <Panel header="Visitors Report" className="panel-primary">
                <ComposableMap
                  projectionConfig={{
                    scale: 205,
                    rotation: [-11, 0, 0],
                  }}
                  width={980}
                  height={551}
                  style={{
                    width: '100%',
                    height: 'auto',
                  }}
                >
                  <ZoomableGroup center={[0, 20]} disablePanning>
                    <Geographies geographyUrl="/geo/world-50m.json">
                      {(geographies, projection) =>
                        geographies.map(
                          (geography, i) =>
                            geography.id !== 'ATA' && (
                              <Geography
                                key={i}
                                geography={geography}
                                projection={projection}
                                style={{
                                  default: {
                                    fill: '#1AD6FD',
                                    stroke: '#1AD6FD',
                                    strokeWidth: 0.75,
                                    outline: 'none',
                                  },
                                  hover: {
                                    fill: '#1D77EF',
                                    stroke: '#1D77EF',
                                    strokeWidth: 0.75,
                                    outline: 'none',
                                  },
                                }}
                              />
                            )
                        )}
                    </Geographies>
                  </ZoomableGroup>
                </ComposableMap>
              </Panel>
            </Col>
          </Row>
        </section>
      </div>
    );
  }
}

DashboardPage.defaultProps = {};

export default DashboardPage;



// WEBPACK FOOTER //
// ./src/pages/DashboardPage.js